import axios from 'axios'
import dayjs from './dayjs'
import Hashes from 'jshashes'
import store from '../store/index'
import {API} from '../api'
import {get_base64} from './function'
import {
  omit as _omit,
  orderBy as _orderBy,
  pick as _pick
} from 'lodash'
import {
  map_graph_by_time_response,
  map_search_report_by_key,
  map_targeting_report_by_key,
  recalculate_metrics
} from './ads_function'
import {
  replace_dashboard__key_metrics, replace_get_product_by_graphql,
  replace_get_product_by_page,
  replace_get_product_performance_v3,
  replace_get_shop_info,
  replace_marketing_get_report,
  replace_marketing_get_search_ads,
  replace_marketing_get_time_graph,
  replace_marketing_pas_get_campaigns,
  replace_marketing_product_selector
} from './_replace'

const MD5 = new Hashes.MD5
const SHA256 = new Hashes.SHA256

export class SPUserV4 {

  constructor() {
    this._id = ''
    this.shop_id = ''
    this.username = ''
    this.password = ''
    this.password_hash = ''
    this.otp_code = ''
    this.user_agent = navigator.userAgent
    this.cookie = []
    this.proxy = ''
    this.sc_fe_session = this.make_sc_fe_session()
    this.sc_fe_ver = '21.110618'
    this.extra_data = {}
    this.x_sp_dfp = ''
    this.navigator_info = {}
    this.ads_version = ''
    this.is_buff = false
    this.buyer_api = ''
    this.seller_api = ''
    this.account_api = ''
    this.is_floor = true
    this.timezone = ''
    this.country = ''
  }

  make_cookie_uuid() {
    var t = {
      rdQpc: function (t, e) {
        return t + e
      }
    }, e = (new Date).getTime()
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (function (n) {
      var r = t.rdQpc(e, 16 * Math.random()) % 16 | 0
      return e = Math.floor(e / 16), ('x' == n ? r : 7 & r | 8).toString(16)
    }))
  }

  get_browser_name() {
    let userAgent = navigator.userAgent
    let browserName

    if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = 'Chrome'
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = 'Firefox'
    } else if (userAgent.match(/safari/i)) {
      browserName = 'Safari'
    } else if (userAgent.match(/opr\//i)) {
      browserName = 'Opera'
    } else if (userAgent.match(/edg/i)) {
      browserName = 'Edge'
    } else {
      browserName = ''
    }

    return browserName
  }

  get_os() {
    let detectedOS = ''

    if (navigator.appVersion.indexOf('Mac') !== -1) {
      detectedOS = 'Mac'
    }

    if (navigator.appVersion.indexOf('Win') !== -1) {
      detectedOS = 'Win'
    }

    if (navigator.appVersion.indexOf('Linux') !== -1) {
      detectedOS = 'Linux'
    }

    return detectedOS
  }

  make_navigator_info() {
    if (this.extra_data && this.extra_data.navigator_info && this.extra_data.navigator_info.cookieUuid) {
      return this.extra_data.navigator_info
    }

    const uuid = this.make_cookie_uuid()

    return {
      'startTime': new Date().getTime(),
      'localWebUnique': '',
      'locationHref': 'https://shopee.vn/seller/login',
      'localStorageEnbale': true,
      'sessionStorageEnbale': true,
      'cookieEnbale': true,
      'userAgent': navigator.userAgent,
      'uuidTrack': 'll new create;cc_ll;ss_ll;',
      'createUuidTime': new Date().getTime(),
      'storageUuid': uuid,
      'cookieUuid': uuid,
      'sessionUuid': uuid,
      'touchSupport': false,
      'touchPoints': 0,
      'browser': this.get_browser_name(),
      'checkBrowser': this.get_browser_name(),
      'os': this.get_os(),
      'platform': navigator.platform,
      'oscpu': '',
      'driverText': '',
      'font': '000111001110000000000101101111100001000011000000000100000001110111110100000000010000100000000010',
      'productSub': navigator.productSub,
      'evalLength': 33,
      'errToSource': false,
      'firstLang': 'en-US',
      'defaultLang': 'en-US',
      'screenSize': '1920;1080',
      'availScreenSize': '1920;1004',
      'isWebglDefender': false,
      'isCanvasDefender': false,
      'isFontDefender': false,
      'isAudioDefender': false,
      'isUaSwitcher': false,
      'webglFPHash': 'de0319a8c86e08d8b40ad2ad61b91928f24538d8',
      'changeWebglDetail': '',
      'changeWebglLayerAmount': 0,
      'canvasID': 'f3f3f836cf4945fe6a2c9544899eb53da54ae3c2',
      'changeCanvasDetail': '',
      'changeCanvasLayerAmount': 0,
      'nodeVersion': '',
      'webGLInc': 'Google Inc. (Intel Inc.)',
      'webGLGpu': 'ANGLE (Intel Inc., Intel(R) Iris(TM) Plus Graphics OpenGL Engine, OpenGL 4.1)',
      'webglVendorAndRenderer': 'Google Inc. (Intel Inc.)~ANGLE (Intel Inc., Intel(R) Iris(TM) Plus Graphics OpenGL Engine, OpenGL 4.1)',
      'audioplayInfo': 'ogg:probably;wav:probably;xm4a:maybe',
      'videoplayInfo': 'ogg:probably;mp4:probably;webm:probably',
      'extraData': '',
      'orientation': 'undefined',
      'cssQuery': false,
      'driverKey': 'key:webdriver;',
      'plugin': 'Chrome PDF Viewer;Chromium PDF Viewer;Microsoft Edge PDF Viewer;PDF Viewer;WebKit built-in PDF',
      'devicePixelRatio': 1,
      'screenLeft': 1595,
      'screenTop': 25,
      'ratiosZoom': 1,
      'cssPerDevice': 1,
      'timeZone': -420,
      'fpColorDepth': 24,
      'hasIndexedDB': true,
      'openDatabase': true,
      'cpuClass': '',
      'deviceMemory': navigator.deviceMemory,
      'CPUCores': navigator.hardwareConcurrency,
      'doNotTrack': 'no',
      'audioFingerPrinting': 99.60974721813864,
      'changeAudioDetail': '',
      'changeAudioLayerAmount': 0,
      'incognitoDetail': '442729463808;4294705152',
      'batteryInfo': 'level:100;charging:true',
      'isPrivateMode': false,
      'isChromium': true,
      'isDebugerMode': false,
      'webrtcIP': '[]',
      'browserSize': '1440-1440;875-796',
      'sellerText': '',
      'recordDetail': '',
      'isTrueClick': true,
      'collectTime': 826
    }
  }

  make_sc_fe_session(e = 16, t = 16) {
    let n = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(""), r = [];
    if (t = t || n.length, e) for (let o = 0; o < e; o++) r[o] = n[0 | Math.random() * t]; else {
      r[8] = r[13] = r[18] = r[23] = "-", r[14] = "4";
      for (let e = 0; e < 36; e++) if (!r[e]) {
        let t = 0 | 16 * Math.random();
        r[e] = n[19 == e ? 3 & t | 8 : t]
      }
    }
    return r.join("")
  }

  make_device_id() {
    var r, o
    'string' == typeof r && (o = 'binary' == r ? new Array(16) : null, r = null)
    var n = (r = r || {}).random || (r.rng || function () {
      return function (r) {
        for (var n = 0, t = r.length; n < t; n++) r[n] = Math.floor(256 * Math.random())
        return r
      }(new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]))
    })()
    if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, o) for (var t = 0; t < 16; ++t) o[0 + t] = n[t]
    return o || function (r) {
      for (var n = [], t = 0; t < 256; ++t) n[t] = (t + 256).toString(16).substr(1)
      t = o || 0
      var a = n
      return a[r[t++]] + a[r[t++]] + a[r[t++]] + a[r[t++]] + '-' + a[r[t++]] + a[r[t++]] + '-' + a[r[t++]] + a[r[t++]] + '-' + a[r[t++]] + a[r[t++]] + '-' + a[r[t++]] + a[r[t++]] + a[r[t++]] + a[r[t++]] + a[r[t++]] + a[r[t++]]
    }(n)
  }

  request(config_params, re_login = true) {
    return new Promise(async resolve => {
      const config = {
        ...config_params,
        agentOptions: {rejectUnauthorized: false}
      }

      try {
        if (!config.headers) {
          config.headers = await this.x_headers_seller(this.cookie)
        }

        if (config.url.includes('_SPC_CDS')) {
          const x_cookie = config.headers.cookie.split(';')
          x_cookie.forEach(e => {
            const qq = e.split('=')
            if (qq[0].trim() === 'SPC_CDS') {
              config.url = config.url.replace('_SPC_CDS', qq[1])
            }
          })
        }

        if (config.url.includes('_csrf_token')) {
          const x_cookie = config.headers.cookie.split(';')
          x_cookie.forEach(e => {
            const qq = e.split('=')
            if (qq[0].trim() === 'CTOKEN' || qq[0].trim() === 'csrftoken') {
              config.url = config.url.replace('_csrf_token', qq[1])
            }
          })
        }

        if (this.sc_fe_session) Object.assign(config.headers, {'sc-fe-session': this.sc_fe_session})
        if (this.sc_fe_session) Object.assign(config.headers, {'sc-fe-ver': this.sc_fe_ver})
        if (this.x_sp_dfp) Object.assign(config.headers, {'x-sp-dfp': this.x_sp_dfp})

        const response = await axios.post(API.URL_API_SRV_2 + '/shopee/submit_request', {
          config: {
            ...config,
            proxy: this.proxy,
          },
          shop_id: this._id,
          buyer_api: this.buyer_api,
          seller_api: this.seller_api,
          account_api: this.account_api
        }, cf())

        if (response.data.errcode || response.data.message === 'token not found') {
          if (re_login) {
            console.log(`shop: ${this.username} - token not found - do retry...`)

            await sleep(1000)

            await this.get_partner_login_init()
            await this.get_shop_info(false)

            const retry_response = await axios.post(API.URL_API_SRV_2 + '/shopee/submit_request', {
              config: {
                ...config,
                proxy: this.proxy,
              },
              shop_id: this._id,
              buyer_api: this.buyer_api,
              seller_api: this.seller_api,
              account_api: this.account_api
            }, cf())

            const new_cookie = retry_response.data.new_cookie
            if (new_cookie) {
              const r1 = JSON.parse(JSON.stringify(this.cookie))
              const r2 = this.cookie = this.join_cookie(this.cookie, new_cookie)
              await this.compare_cookie(r1, r2)
            }
            return resolve(retry_response)
          }

          return resolve(response)
        } else {
          const new_cookie = response.data.new_cookie
          if (new_cookie) {
            const r1 = JSON.parse(JSON.stringify(this.cookie))
            const r2 = this.cookie = this.join_cookie(this.cookie, new_cookie)
            await this.compare_cookie(r1, r2)
          }
          return resolve(response)
        }
      } catch (e) {
        console.error(e)
        return resolve({error: e})
      }
    })
  }

  join_cookie(r1, r2) {
    const json_cookie = {}

    r1.forEach(e => {
      json_cookie[e.name.toString()] = e.value
    })

    r2.forEach(e => {
      json_cookie[e.name.toString()] = e.value
    })

    const cookie_array = []
    Object.keys(json_cookie).forEach(e => {
      if (typeof e !== 'undefined') {
        cookie_array.push({
          name: e,
          value: json_cookie[e.toString()]
        })
      }
    })

    return cookie_array
  };

  async compare_cookie(r1, r2) {
    const _r1 = JSON.stringify(_orderBy(r1, 'name'))
    const _r2 = JSON.stringify(_orderBy(r2, 'name'))

    if (_r1 !== _r2) {
      console.log(this.username, 'r is different')
      await UPDATE_SELLER_ACCOUNT(this._id, this.username, this.password, this.shop_id, this.cookie, '')
    }
  }

  async x_headers_buyer(input_cookie) {
    if (typeof input_cookie === 'object') {
      const x_cookie = input_cookie
      input_cookie = ''
      x_cookie.forEach(e => {
        input_cookie += `${e.name}=${e.value}; `
      })
    }

    return {
      'user-agent': this.user_agent,
      'cookie': input_cookie,
      'referer': 'https://shopee.vn/',
      // 'x-api-source': 'pc',
      // 'x-requested-with': 'XMLHttpRequest',
      'authority': 'shopee.vn',
      'accept': 'application/json, text/plain, */*',
      'accept-language': 'en,vi;q=0.9,en-US;q=0.8,vi-VN;q=0.7',
      'sec-ch-ua': '"Chromium";v="112", "Google Chrome";v="112", "Not:A-Brand";v="99"',
      'sec-ch-ua-mobile': '?0',
      'sec-ch-ua-platform': '"macOS"',
      'sec-fetch-dest': 'empty',
      'sec-fetch-mode': 'cors',
      'sec-fetch-site': 'same-origin'
    }
  };

  async x_headers_seller(input_cookie) {
    if (typeof input_cookie === 'object') {
      const x_cookie = input_cookie
      input_cookie = ''
      x_cookie.forEach(e => {
        input_cookie += `${e.name}=${e.value}; `
      })
    }

    return {
      'user-agent': this.user_agent,
      'cookie': input_cookie,
      'referer': 'https://banhang.shopee.vn/',
      'authority': 'banhang.shopee.vn',
      'accept': 'application/json, text/plain, */*',
      'accept-language': 'en,vi;q=0.9,en-US;q=0.8,vi-VN;q=0.7',
      'sec-ch-ua': '"Chromium";v="112", "Google Chrome";v="112", "Not:A-Brand";v="99"',
      'sec-ch-ua-mobile': '?0',
      'sec-fetch-dest': 'empty',
      'sec-fetch-mode': 'cors',
      'sec-fetch-site': 'same-origin'
    }
  };

  to_mipee_cookie() {
    const result = {}
    this.cookie.forEach(e => {
      result[e.name] = e.value
    })
    return result
  }

  async get_product_by_page(page_index) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/v3/mpsku/list/v2/get_product_list?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&page_number=${page_index}&page_size=24&list_type=all&need_ads=true`,
      headers: await this.x_headers_seller(this.cookie)
    })

    if (response && response.data && response.data.data && response.data.data.products) {
      for (const item of response.data.data.products) {
        item.images = [item.cover_image]
        for (const model of item.model_list) {
          model.price_info = model.price_detail
          model.price_info.normal_price = model.price_info.origin_price
        }
      }
    }

    replace_get_product_by_page(this, response)

    return response && response.data && response.data.data && response.data.data.products ? response.data.data.products : []
  }

  marketing_get_keyword_volume(keyword, product_id, placement = '0') {
    return new Promise(async resolve => {
      try {
        const response = await this.request({
          url: 'https://banhang.shopee.vn/api/pas/v1/setup_helper/search_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
          method: 'POST',
          headers: await this.x_headers_seller(this.cookie),
          body: {
            keyword: keyword,
            placement: +placement,
            suggest_log_data: {
              page: 'suggest_creation'
            },
            item_id: product_id || null
          },
          json: true
        })

        for (const item of response.data.data) {
          item.algorithm = item.product_suggest_log_data ? item.product_suggest_log_data.algorithm : 'kwrcmdv2'
          item.recommend_price = this.m__calculate(item.recommended_price / 100000)
        }

        if (response && response.data && response.data.data) {
          axios.post(API.URL_API_SRV_2 + '/mipee/keyword/log_relevance', {
            placement: +placement,
            shop_id: this.shop_id,
            item_id: product_id,
            keywords: response.data.data,
            country: this.country
          }, cf())
            .catch(console.error)
        }

        const body = response.data

        if (body.data[0] && body.data[0].search_volume > 0) {
          resolve(body.data[0])
        }

        let result = body.data.find(i => i.keyword === keyword && i.search_volume > 0)
        if (!result) {
          result = body.data.find(i => i.keyword.normalize() === keyword.normalize() && i.search_volume > 0)
        }
        if (!result) {
          result = body.data.find(i => i.keyword.normalize() === remove_unicode(keyword.normalize()) && i.search_volume > 0)
        }
        if (!result) {
          result = body.data[0]
        }
        resolve(result)
      } catch (error) {
        resolve(null)
      }
    })
  }

  async marketing_get_hint_keyword(base_keyword) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/pas/v1/setup_helper/list_keyword_hint/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      body: {
        keyword: base_keyword,
        placement: 3,
        suggest_log_data: {
          page: 'suggest_creation'
        },
        item_id: null
      },
      headers: await this.x_headers_seller(this.cookie),

      json: true
    })

    return response.data.data
  }

  async marketing_get_campaign(start_time, end_time, offset, limit) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/campaign_statistics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&campaign_type=keyword&filter_content=all&sort_key=performance&sort_direction=1&search_content=&start_time={start_time}&end_time={end_time}&offset={offset}&limit={limit}'
        .replace('{start_time}', dayjs(start_time).startOf('d').unix().toString())
        .replace('{end_time}', dayjs(end_time).endOf('d').unix().toString())
        .replace('{offset}', offset)
        .replace('{limit}', limit),
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data && response.data.data && response.data.data.campaign_ads_list ? response.data.data.campaign_ads_list : []
  }

  async marketing_get_campaign_detail(campaign_id, campaign_type = 'product') {
    // todo: test
    // const test_response = await this.request({
    //   url: 'https://banhang.shopee.vn/api/marketing/v3/pas/campaign/?campaignid={campaign_id}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2'
    //     .replace('{campaign_id}', campaign_id),
    //   headers: await this.x_headers_seller(this.cookie),
    //   json: true
    // })
    // console.log(test_response)

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/${campaign_type}/get/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_id,
        header: {}
      },
      json: true
    })

    if (response && response.data && response.data.data) {
      const ads = response.data.data.ads_list ? response.data.data.ads_list[0] : {}
      const campaign = response.data.data.campaign
      const new_campaign = {
        advertisements: [],
        campaign: {
          ...campaign,
          campaignid: campaign.campaign_id,
          daily_quota: this.m__calculate(campaign.daily_budget / 100000),
          total_quota: this.m__calculate(campaign.total_quota / 100000),
        }
      }

      if (campaign_type === 'product') {
        if (campaign.bidding_strategy === 'roi_two') {
          const placement4 = {
            placement: 4,
            itemid: ads.item_id,
            extinfo: {
              keywords: [],
              target: {},
              target_broad_roi: campaign.roi_two ? campaign.roi_two.target : null,
              roi_two: campaign.roi_two ? campaign.roi_two.target : null,
              rapid_boost: campaign.rapid_boost
            },
          }
          new_campaign.advertisements.push(placement4);
        }
        if (campaign.bidding_strategy === 'auto') {
          if (campaign.product_placement === 'all' || campaign.product_placement === 'search_product') {
            const placement4 = {
              placement: 4,
              itemid: ads.item_id,
              extinfo: {
                keywords: [],
                target: {}
              },
            }
            new_campaign.advertisements.push(placement4)
          }
          if (campaign.product_placement === 'all' || campaign.product_placement === 'targeting') {
            const placement8 = {
              placement: 8,
              itemid: ads.item_id,
              extinfo: {
                target: {
                  price: 480,
                }
              },
              status: 1
            }
            new_campaign.advertisements.push(placement8)
          }
        }
        if (campaign.bidding_strategy === 'manual') {
          if (campaign.product_placement === 'all' || campaign.product_placement === 'search_product') {
            const placement0 = {
              placement: 0,
              itemid: ads.item_id,
              extinfo: {
                keywords: [],
                target: {},
                pricing_type: campaign.ecpc ? 2 : 1,
              }
            }
            const keyword_response = await this.request({
              url: `https://banhang.shopee.vn/api/pas/v1/${campaign_type}/manual/list_keyword_with_recommended_price/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
              method: 'POST',
              headers: await this.x_headers_seller(this.cookie),
              body: {
                campaign_id,
                need_recommended_price: true,
                header: {}
              },
              json: true
            })
            if (keyword_response && keyword_response.data && keyword_response.data.data) {
              placement0.extinfo.keywords = keyword_response.data.data.map(i => {
                const k = {...i.keyword}
                k.price = this.m__calculate(i.keyword.bid_price / 100000)
                k.status = this.m__map_keyword_state(i.keyword)
                k.match_type = i.keyword.match_type === 'broad' ? 1 : 0
                k.recommend_price = this.m__calculate(i.keyword.recommended_price / 100000)
                return k
              })
            }
            new_campaign.advertisements.push(placement0)
          }
          if (campaign.product_placement === 'all' || campaign.product_placement === 'targeting') {
            if (campaign.display_location.daily_discover) {
              const placement2 = {
                placement: 2,
                itemid: ads.item_id,
                extinfo: {
                  target: {
                    price: this.m__calculate(campaign.display_location.daily_discover.bid_price / 100000),
                  },
                  pricing_type: campaign.ecpc ? 2 : 1
                },
                status: campaign.display_location.daily_discover.state === 'active' ? 1 : 3
              }
              new_campaign.advertisements.push(placement2)
            }
            if (campaign.display_location.you_may_also_like) {
              const placement5 = {
                placement: 5,
                itemid: ads.item_id,
                extinfo: {
                  target: {
                    price: this.m__calculate(campaign.display_location.you_may_also_like.bid_price / 100000),
                  },
                  pricing_type: campaign.ecpc ? 2 : 1
                },
                status: campaign.display_location.you_may_also_like.state === 'active' ? 1 : 3
              }
              new_campaign.advertisements.push(placement5)
            }
          }
        }
      }

      if (campaign_type === 'shop') {
        if (campaign.bidding_strategy === 'auto') {
          const placement20 = {
            placement: 20,
            extinfo: {
              keywords: [],
              shop_customisation: {},
              target: {}
            },
          }
          new_campaign.advertisements.push(placement20)
        }
        if (campaign.bidding_strategy === 'manual') {
          const placement3 = {
            placement: 3,
            extinfo: {
              keywords: [],
              shop_customisation: {
                image_url: campaign.creative.image_url,
                display_title: campaign.creative.tagline,
                collection_id: 0
              },
              target: {},
              pricing_type: campaign.ecpc ? 2 : 1,
            },
          }
          const keyword_response = await this.request({
            url: `https://banhang.shopee.vn/api/pas/v1/${campaign_type}/manual/list_keyword_with_recommended_price/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
            method: 'POST',
            headers: await this.x_headers_seller(this.cookie),
            body: {
              campaign_id,
              header: {}
            },
            json: true
          })
          if (keyword_response && keyword_response.data && keyword_response.data.data) {
            placement3.extinfo.keywords = keyword_response.data.data.map(i => {
              const k = {...i}
              k.price = this.m__calculate(i.bid_price / 100000)
              k.status = this.m__map_keyword_state(i)
              k.match_type = i.match_type === 'broad' ? 1 : 0
              k.recommend_price = this.m__calculate(i.recommended_price / 100000)
              return k
            })
          }
          new_campaign.advertisements.push(placement3)
        }
      }

      if (campaign_type === 'live_stream') {
        const placement4 = {
          placement: 4,
          itemid: null,
          extinfo: {
            keywords: [],
            target: {},
            target_broad_roi: campaign.roi_two ? campaign.roi_two.target : null,
            roi_two: campaign.roi_two ? campaign.roi_two.target : null,
            rapid_boost: campaign.rapid_boost
          },
          objective: campaign.objective,
          time_slot_list: campaign.time_slot_list
        }
        new_campaign.advertisements.push(placement4);
      }

      return {
        code: 0,
        data: new_campaign
      }
    }

    return response ? response.data : null

    // const response = await this.request({
    //   url: 'https://banhang.shopee.vn/api/marketing/v3/pas/campaign/?campaignid={campaign_id}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2'
    //     .replace('{campaign_id}', campaign_id),
    //   headers: await this.x_headers_seller(this.cookie),
    //   json: true
    // })
    //
    // replace_marketing_get_campaign_detail(this, response)
    //
    // return response.data

    // const response = await this.request({
    //   url: `https://banhang.shopee.vn/api/marketing/v3/pas/get_campaign_list_by_id/?placement_list=\\[4,0,3,20,1,2,5,8\\]&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
    //   method: 'POST',
    //   headers: await this.x_headers_seller(this.cookie),
    //   body: {campaignid_list: [campaign_id]},
    //   json: true
    // })
    //
    // if (response && response.data && response.data.debug_detail === 'placement error') {
    //   const detail_response = await this.marketing_pas_get_campaign_detail(campaign_id);
    //   return detail_response ? map_to_pas_campaign(detail_response) : null;
    // }
    //
    // replace_marketing_get_campaign_detail(this, response)

    // response.data.data = response.data.data.campaign_ads_list[0]
    // return response.data
  }

  async marketing_get_suggest_keyword_price(item_id, keywords, placement = 0) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/get_suggest_keyword_price/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        itemid: item_id,
        keyword_list: keywords,
        placement: placement
      },
      json: true
    })

    return response.data
  }

  async marketing_detail_report_by_keyword(item_id, start_time, end_time, placement_list = '[0]') {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report/detail_report_by_keyword/?start_time={start_time}&end_time={end_time}&placement_list={placement_list}&agg_interval=96&need_detail=0&itemid={item_id}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2'
        .replace('{item_id}', item_id)
        .replace('{start_time}', Math.floor(start_time).toString())
        .replace('{end_time}', Math.floor(end_time).toString())
        .replace('{placement_list}', placement_list),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_detail_report_by_keyword_v2(campaign_id, item_id, start_time, end_time, placement_list = '[0]') {
    if (includes_fixed_shop(this.shop_id)) {
      let agg_type = 'keyword'
      if (placement_list === '[4]') agg_type = 'product_placement_auto_strategy'

      let response = await this.marketing_get_report(agg_type, 'product', start_time, end_time, {campaign_id: campaign_id})
      if (response) {
        if (placement_list === '[4]') {
          response.data = response.data.filter(i => i.key === 'search_product')
        }
        response = map_search_report_by_key(response)
      }
      return response
    }

    return this.marketing_detail_report_by_keyword(item_id, start_time, end_time, placement_list)
  }

  async marketing_update_campaign(campaign) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/campaign/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: campaign,
      json: true
    })
  }

  async marketing_mass_edit(body) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v3/pas/mass_edit/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: body,
      json: true
    })
  }

  async marketing_mass_edit_update_quota_v2(body) {
    if (this.is_buff) return {code: 0}

    if (includes_fixed_shop(this.shop_id)) {
      const new_body = {
        campaign_id_list: body.campaignid_list,
        type: 'change_budget',
        change_budget: {
          daily_budget: this.m__calculate(body.daily_quota) * 100000,
          total_budget: 0,
          budget_log_key: 'budget_log_' + this.make_device_id()
        }
      }

      return await this.request({
        url: `https://banhang.shopee.vn/api/pas/v1/homepage/mass_edit/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
        method: 'PUT',
        headers: await this.x_headers_seller(this.cookie),
        body: new_body,
        json: true
      })
    }

    return this.marketing_mass_edit(body)
  }

  async marketing_create_campaign(campaign) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/campaign/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: campaign,
      json: true
    })
  }

  async marketing_suggest_keyword(item_id, placement = '0') {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/pas/v1/setup_helper/list_recommended_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        suggest_log_data: {page: 'suggest_creation'},
        item_id: item_id,
        placement: +placement
      },
      json: true
    })

    if (response.data && response.data.data) {
      for (const item of response.data.data) {
        item.algorithm = item.product_suggest_log_data ? item.product_suggest_log_data.algorithm : 'kwrcmdv2'
        item.recommend_price = this.m__calculate(item.recommended_price / 100000)
      }

      axios.post(API.URL_API_SRV_2 + '/mipee/keyword/log_relevance', {
        placement: +placement,
        shop_id: this.shop_id,
        item_id: item_id,
        keywords: response.data.data,
        country: this.country
      }, cf())
        .catch(console.error)
    }

    return response.data
  }

  async marketing_suggest_keywords(keyword, item_id) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/pas/v1/setup_helper/search_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        keyword: keyword,
        placement: item_id ? 0 : 3,
        suggest_log_data: {
          page: 'suggest_creation'
        },
        item_id: item_id || null
      },
      json: true
    })

    if (response && response.data && response.data.data) {
      for (const item of response.data.data) {
        item.algorithm = item.product_suggest_log_data ? item.product_suggest_log_data.algorithm : 'kwrcmdv2'
        item.recommend_price = this.m__calculate(item.recommended_price / 100000)
      }

      axios.post(API.URL_API_SRV_2 + '/mipee/keyword/log_relevance', {
        placement: +item_id ? 0 : 3,
        shop_id: this.shop_id,
        item_id: item_id,
        keywords: response.data.data,
        country: this.country
      }, cf())
        .catch(console.error)
    }

    return response.data
  }

  async marketing_get_item_status(item_id_list) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/get_item_status/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {item_id_list},
      json: true
    })

    return response.data
  }

  async marketing_get_balance() {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/account/?need_create=0&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
    return response.data
  }

  async marketing_get_time_graph(campaign_type, start_time, end_time, filter_params, custom_agg_interval = null) {
    const split_times = split_data_every_three_months(start_time * 1000, end_time * 1000).reverse()

    const data = {
      report_aggregate: {},
      report_by_time: []
    }
    let has_code_5 = false

    for (const split_time of split_times) {
      const agg_interval = custom_agg_interval || generate_agg_interval(split_time.start * 1000, split_time.end * 1000)

      const response = await this.request({
        url: 'https://banhang.shopee.vn/api/pas/v1/report/get_time_graph/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
        method: 'POST',
        headers: await this.x_headers_seller(this.cookie),
        body: {
          agg_interval: agg_interval,
          campaign_type: campaign_type,
          start_time: split_time.start,
          end_time: split_time.end,
          filter_params: filter_params,
          need_target_broad_roi_setting: !['shop', 'live_stream', 'product_mpd'].includes(campaign_type),
          header: {},
        },
        json: true
      })

      if (response && response.data && response.data.data) {
        for (const key of Object.keys(response.data.data.report_aggregate)) {
          if (!data.report_aggregate[key]) {
            data.report_aggregate[key] = 0
          }
          data.report_aggregate[key] += +response.data.data.report_aggregate[key]
        }
        recalculate_metrics(data.report_aggregate)

        data.report_by_time = [...response.data.data.report_by_time, ...data.report_by_time]
      }

      if (response && response.data && response.data.code === 5) {
        const response = await axios.post(API.URL_API_SRV_2 + '/mipee/shopee_ads/get_metrics_report', {
          shop_id: this._id,
          start_time: split_time.start,
          end_time: split_time.end,
        }, cf())
        if (response.data && response.data.data) {
          for (const key of Object.keys(response.data.data.report_aggregate)) {
            if (!data.report_aggregate[key]) {
              data.report_aggregate[key] = 0
            }
            data.report_aggregate[key] += +response.data.data.report_aggregate[key]
          }
          recalculate_metrics(data.report_aggregate)

          data.report_by_time = [...response.data.data.report_by_time, ...data.report_by_time]
        }
      }

      replace_marketing_get_time_graph(this, response)
    }

    if (has_code_5) data.report_by_time = []

    return {data: data}
  }

  async marketing_get_time_graph_by_month(campaign_type, start_time, end_time, filter_params) {
    const agg_interval = generate_agg_interval(start_time * 1000, end_time * 1000)

    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/pas/v1/report/get_time_graph/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        agg_interval,
        campaign_type,
        start_time,
        end_time,
        filter_params,
        need_target_broad_roi_setting: !['shop', 'live_stream', 'product_mpd'].includes(campaign_type),
        header: {}
      },
      json: true
    })

    return response ? response.data : null
  }

  async marketing_get_report(agg_type, campaign_type, start_time, end_time, filter_params) {
    const split_times = split_data_every_three_months(start_time * 1000, end_time * 1000).reverse()

    const data = []

    for (const split_time of split_times) {
      const response = await this.request({
        url: 'https://banhang.shopee.vn/api/pas/v1/report/get/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
        method: 'POST',
        headers: await this.x_headers_seller(this.cookie),
        body: {
          agg_type,
          campaign_type,
          start_time: split_time.start,
          end_time: split_time.end,
          filter_params,
          header: {},
          need_ratio: true
        },
        json: true
      })

      replace_marketing_get_report(this, response)

      if (response && response.data && response.data.data) {
        for (const item of response.data.data) {
          const found = data.find(i => i.key === item.key)
          if (found) {
            for (const key of Object.keys(item.metrics)) {
              if (!found.metrics[key]) found.metrics[key] = 0
              found.metrics[key] += item.metrics[key]
            }
            recalculate_metrics(found.metrics)
          } else {
            data.push(item)
          }
        }
      }
    }

    return {data: data}
  }

  async marketing_invalid_keyword(keyword_list) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/keyword/invalid_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {keyword_list},
      json: true
    })

    return response.data
  }

  async marketing_export_report(campaign_id, item_id, start_time, end_time) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report/export_detail_report_by_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&campaignid={campaign_id}&itemid={item_id}&start_time={start_time}&end_time={end_time}'
        // url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report/export_item_report_by_placement/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&itemid={item_id}&campaignid={campaign_id}&start_time={start_time}&end_time={end_time}'
        .replace('{campaign_id}', campaign_id)
        .replace('{item_id}', item_id)
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_get_products(offset, limit, need_item_model = '1') {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/product_selector/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&offset={offset}&limit={limit}&is_ads=1&need_brand=0&need_item_model={need_item_model}'
        .replace('{offset}', offset)
        .replace('{limit}', limit)
        .replace('{need_item_model}', need_item_model),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_product_selector(offset, limit, type, search_type, search_content) {
    // let url = 'https://banhang.shopee.vn/api/marketing/v3/pas/product_selector/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&offset={offset}&limit={limit}&is_ads=1&campaign_type={type}'
    let url = 'https://banhang.shopee.vn/api/marketing/v4/public/product_selector/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&offset={offset}&limit={limit}&is_ads=1&campaign_type={type}'
    if (search_content) {
      url += '&search_type={search_type}&search_content={search_content}'
    }

    const response = await this.request({
      url: url
        .replace('{offset}', offset)
        .replace('{limit}', limit)
        .replace('{type}', type)
        .replace('{search_type}', search_type)
        .replace('{search_content}', encodeURIComponent(search_content)),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    replace_marketing_product_selector(this, response)

    return response.data
  }

  async campaign_report_marketing(start_time, end_time, type = 'keyword') {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/campaign_statistics/export/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&campaign_type={type}&start_time={start_time}&end_time={end_time}'
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{type}', type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_report_file_export(start_time, end_time, report_type) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report_file/export/?report_type={report_type}&start_time={start_time}&end_time={end_time}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2'
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{report_type}', report_type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_report_file_batch(fileid_list) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report_file/batch/?fileid_list={fileid_list}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2'
        .replace('{fileid_list}', fileid_list),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_report_file_download(fileid) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report_file/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&fileid={fileid}'
        .replace('{fileid}', fileid),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async get_categories() {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/v3/category/get_all_category_list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&version=3.1.0',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async get_shop_categories() {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/shopcategory/v3/category/page_active_collection_list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&page_number=1&page_size=100',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async get_product_by_shop_category(shop_category_id) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/public/product_search/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&category_type=my_shop&category={shop_category_id}'
        .replace('{shop_category_id}', shop_category_id),
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  make_password_hash(password) {
    return SHA256.hex(MD5.hex(password.slice(0, 16)).toString())
  }

  async get_shop_info(re_login = true) {
    const find = this.cookie.find(i => i.name === 'SPC_CDS')
    if (!find) {
      this.cookie.push({
        name: 'SPC_CDS',
        value: this.make_device_id()
      })
    }

    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/v2/login/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie)
    }, re_login)

    replace_get_shop_info(this, response)

    return response
  }

  async get_web_experiments(shop_info) {
    return await this.request({
      url: 'https://accounts.shopee.vn/api/v4/abtest/traffic/get_web_experiments',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie)
    })
  }

  initial_for_seller_mode() {
    return new Promise(async resolve => {
      let current_cookie = this.to_mipee_cookie()
      if (typeof current_cookie['SPC_CDS'] === 'undefined' || current_cookie['SPC_CDS'] === '') {
        this.cookie.push({
          name: 'SPC_CDS',
          value: this.make_device_id()
        })
      }
      let password_hash = SHA256.hex(MD5.hex(this.R_password).toString())
      await this.request({
        url: 'https://banhang.shopee.vn/api/v1/check_pass_and_cache/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
        method: 'POST',
        headers: await this.x_headers_seller(this.cookie),
        form: {
          password_hash: password_hash
        }
      })
      // logger('Mở khóa mật khẩu cài đặt');
      resolve(true)
    })
  }

  async get_product_by_ids(product_ids) {
    // return await this.request({
    //   url: 'https://banhang.shopee.vn/api/v3/product/page_product_list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&product_ids={product_ids}&page_size=100&source=marketing&without_limit=true&version=3.1.0'
    //     .replace('{product_ids}', product_ids),
    //   headers: await this.x_headers_seller(this.cookie),
    //   json: true
    // })

    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/get_item_list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        item_id_list: product_ids,
        campaign_type: 'keyword',
        status_type: 0
      },
      json: true
    })
  }

  async get_product_detail(product_id) {
    return await this.request({
      // url: 'https://banhang.shopee.vn/api/v3/product/get_product_detail/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&product_id={product_id}&version=3.2.0'
      url: 'https://banhang.shopee.vn/api/v3/product/get_product_info/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&product_id={product_id}&version=3.2.0&is_draft=false'
        .replace('{product_id}', product_id),
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async targeting_marketing_get_campaign(start_time, end_time, offset, limit, campaign_state = 'all') {
    const url = `https://banhang.shopee.vn/api/marketing/v3/pas/homepage/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&campaign_type=targeting&campaign_state={campaign_state}&sort_key=performance&sort_direction=1&search_content=&start_time={start_time}&end_time={end_time}&offset={offset}&limit={limit}`
      .replace('{start_time}', dayjs(start_time).startOf('d').unix().toString())
      .replace('{end_time}', dayjs(end_time).endOf('d').unix().toString())
      .replace('{offset}', offset)
      .replace('{limit}', limit)
      .replace('{campaign_state}', campaign_state)

    const response = await this.request({
      url,
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data && response.data.data && response.data.data.campaign_ads_list ? response.data.data.campaign_ads_list : []
  }

  async targeting_marketing_get_suggest_price(product_id) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/get_suggest_price/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        itemids: [product_id],
        placement_list: [1, 2, 5]
      },
      json: true
    })

    return response.data.data
  }

  async targeting_marketing_get_segment_suggest_price(product_id) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/get_segment_suggest_price/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        itemids: [product_id],
        placement_list: [1, 2, 5]
      },
      json: true
    })

    return response.data.data
  }

  async target_marketing_get_report(product_id, start_time, end_time) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report/item_report_by_placement/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&placement_list={placement_list}&itemid={product_id}'
        .replace('{product_id}', product_id)
        .replace('{start_time}', Math.floor(start_time).toString())
        .replace('{end_time}', Math.floor(end_time).toString())
        .replace('{placement_list}', '[1,2,5,8]'),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data.data
  }

  async target_marketing_get_report_v2(campaign_id, product_id, start_time, end_time) {
    if (includes_fixed_shop(this.shop_id)) {
      let response = await this.marketing_get_report('display_location', 'product', start_time, end_time, {campaign_id: campaign_id})
      if (response) response = map_targeting_report_by_key(response)
      return response
    }

    return this.target_marketing_get_report(product_id, start_time, end_time)
  }

  async targeting_marketing_get_item_status(product_id) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v4/pas/get_item_status/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        item_id_list: [product_id]
      },
      json: true
    })

    return response.data.data
  }

  async targeting_marketing_export_report(campaign_id, product_id, start_time, end_time) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report/export_item_report_by_placement/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&itemid={product_id}&campaignid={campaign_id}&start_time={start_time}&end_time={end_time}'
        .replace('{campaign_id}', campaign_id)
        .replace('{product_id}', product_id)
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async targeting_marketing_get_buyer_segment() {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/get_buyer_segment/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async targeting_marketing_item_report_by_segments(start_time, end_time, itemid) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report/item_report_by_segments/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&itemid={itemid}'
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{itemid}', itemid),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async targeting_marketing_update_segment(data) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/target/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })
  }

  async targeting_marketing_update_campaign_price(campaignid, base_price) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/target/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaignid,
        base_price
      },
      json: true
    })
  }

  async targeting_marketing_update_premium_rate(campaignid, placement, premium_rate) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/target/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaignid,
        ads_list: [{
          placement,
          premium_rate
        }]
      },
      json: true
    })
  }

  async targeting_marketing_update_status(campaignid, placement, status) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/target/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaignid,
        ads_list: [{
          placement,
          status
        }]
      },
      json: true
    })
  }

  async targeting_get_buyer_segment() {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/get_buyer_segment/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async shop_ads_marketing_get_campaign(start_time, end_time, offset, limit) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/campaign_statistics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&campaign_type=shop&filter_content=all&sort_key=performance&sort_direction=1&search_content=&start_time={start_time}&end_time={end_time}&offset={offset}&limit={limit}'
        .replace('{start_time}', dayjs(start_time).startOf('d').unix().toString())
        .replace('{end_time}', dayjs(end_time).endOf('d').unix().toString())
        .replace('{offset}', offset)
        .replace('{limit}', limit),
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data && response.data.data && response.data.data.campaign_ads_list ? response.data.data.campaign_ads_list : []
  }

  async shop_ads_marketing_detail_report_by_keyword(adsid, start_time, end_time) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report/detail_report_by_keyword/?start_time={start_time}&end_time={end_time}&placement_list={placement_list}&agg_interval=96&need_detail=0&adsid={adsid}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2'
        .replace('{adsid}', adsid)
        .replace('{start_time}', Math.floor(start_time))
        .replace('{end_time}', Math.floor(end_time))
        .replace('{placement_list}', '[3]'),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async shop_ads_get_categories() {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/shopcategory/v3/category/query_collection_list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async shop_ads_get_suggest_keyword_price(keyword) {
    const response = await this.request({
      // url: 'https://banhang.shopee.vn/api/pas/v1/setup_helper/search_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      url: 'https://banhang.shopee.vn/api/pas/v1/setup_helper/list_recommended_keyword/',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        keyword: keyword,
        campaign_type: 'shop',
        placement: 3,
        suggest_log_data: {page: 'suggest_creation'}
      },
      json: true
    })

    if (response && response.data && response.data.data) {
      for (const keyword of response.data.data) {
        keyword.recommend_price = this.m__calculate(+keyword.recommended_price / 100000)
      }
    }

    return response.data
  }

  async shop_ads_search_keywords(keyword) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/pas/v1/setup_helper/search_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        keyword: keyword,
        campaign_type: 'shop',
        placement: 3,
        suggest_log_data: {page: 'suggest_creation'}
      },
      json: true
    })

    if (response && response.data && response.data.data) {
      for (const keyword of response.data.data) {
        keyword.recommend_price = this.m__calculate(+keyword.recommended_price / 100000)
      }
    }

    return response.data
  }

  async shop_ads_marketing_export_report(campaign_id, ads_id, start_time, end_time) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/report/export_shop_ads_detail_report_by_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&campaignid={campaign_id}&adsid={ads_id}&start_time={start_time}&end_time={end_time}'
        .replace('{campaign_id}', campaign_id)
        .replace('{ads_id}', ads_id)
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_get_flag(flag_list = '12,13,14') {
    const response = await this.request({
      // url: 'https://banhang.shopee.vn/api/marketing/v3/public/flag_list/?flag_list=[{flag_list}]&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2'
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/flag_list/?flag_list=[{flag_list}]&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2'
        .replace('{flag_list}', flag_list),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_update_flag(flag_value_list = []) {
    if (this.is_buff) return {code: 0}

    const response = await this.request({
      // url: 'https://banhang.shopee.vn/api/marketing/v3/public/flag/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      url: 'https://banhang.shopee.vn/api/marketing/v3/pas/flag/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {flag_value_list},
      json: true
    })

    return response.data
  }

  async get_payment_info() {
    return this.request({
      url: 'https://accounts.shopee.vn/api/v4/account/basic/get_payment_info',
      headers: await this.x_headers_seller(this.cookie)
    }, false)
  }

  async get_partner_login_init() {
    return this.request({
      url: 'https://accounts.shopee.vn/api/v4/account/get_partner_login_init?partner=seller',
      headers: await this.x_headers_seller(this.cookie)
    }, false)
  }

  async seller_login(update = true) {
    const current_cookie = this.to_mipee_cookie()
    if (typeof current_cookie['SPC_CDS'] === 'undefined' || current_cookie['SPC_CDS'] === '') {
      this.cookie.push({
        name: 'SPC_CDS',
        value: this.make_device_id()
      })
    }

    if (this.username && (this.password || this.password_hash)) {
      const form_data = {
        // captcha: '',
        // captcha_key: '',
        // remember: 'true',
        // password_hash: this.password ? this.make_password_hash(this.password) : this.password_hash
        password: this.password ? this.make_password_hash(this.password) : this.password_hash,
        support_ivs: true,
        client_identifier: {security_device_fingerprint: ''}
      }
      if (this.otp_code) {
        form_data.vcode = this.otp_code
      }

      if (this.username.includes('@')) {
        form_data.email = this.username
      }
      if (!isNaN(this.username) && this.username.length === 9 && !this.username.startsWith('0')) {
        this.username = '0' + this.username
      }
      if (!isNaN(this.username) && this.username.startsWith('0') && this.username.length === 10) {
        form_data.phone = '84' + this.username.substring(1)
      }
      if (this.username.startsWith('84')) {
        form_data.phone = this.username.toString()
      }
      if ((typeof form_data.phone === 'undefined' || form_data.phone.length < 2) && typeof form_data.email === 'undefined') {
        form_data.username = this.username
      }

      const response = await this.request({
        method: 'POST',
        url: 'https://accounts.shopee.vn/api/v4/account/login_by_password',
        headers: await this.x_headers_seller(this.cookie),
        body: form_data
      })

      if (response.data && response.data.data && response.data.data.userid) {
        response.data = response.data.data

        const info = await this.get_shop_info()
        Object.assign(response.data, info.data)
      }

      return response.data
    } else {
      return null
    }
  }

  async seller_get_profile() {
    const profile_resp = await this.request({
      url: 'https://banhang.shopee.vn/api/v2/login/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie)
    })

    return profile_resp.data
  }

  async anti_fraud_ivs_method(u_token) {
    const response = await this.request({
      // url: `https://accounts.shopee.vn/api/v4/anti_fraud/ivs/methods`,
      url: `https://shopee.vn/api/v4/anti_fraud/ivs/methods`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        event: 1,
        u_token: u_token
      },
      json: true
    })

    return response.data
  }

  async anti_fraud_verify_email(data) {
    const response = await this.request({
      // url: `https://accounts.shopee.vn/api/v4/anti_fraud/ivs/link/email_verify`,
      url: `https://shopee.vn/api/v4/anti_fraud/ivs/link/email_verify`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async anti_fraud_verify_sms(data) {
    const response = await this.request({
      url: `https://accounts.shopee.vn/api/v4/anti_fraud/ivs/link/verify`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async anti_fraud_get_verify_status(data) {
    const response = await this.request({
      // url: `https://accounts.shopee.vn/api/v4/anti_fraud/ivs/link/get_status`,
      url: `https://shopee.vn/api/v4/anti_fraud/ivs/link/get_status`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async anti_fraud_verify_token(data) {
    const response = await this.request({
      // url: `https://accounts.shopee.vn/api/v4/anti_fraud/ivs/token/verify`,
      url: `https://shopee.vn/api/v4/anti_fraud/ivs/token/verify`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async anti_fraud_get_account_info(data) {
    const response = await this.request({
      url: `https://accounts.shopee.vn/api/v4/account/basic/get_account_info`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async anti_fraud_login_ivs(data) {
    const response = await this.request({
      url: `https://accounts.shopee.vn/api/v4/account/basic/login_ivs`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async get_product_by_graphql(product_ids) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v4/graphql/query/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        'query': 'query Products($productIds: [String], $statusType: Int) {\n      products(productIds: $productIds, statusType: $statusType) {\n  items {\n    itemid,\n    name,\n    images,\n    status,\n    inputOriginPrice,\n    originPrice,\n    normalStock,\n    pffTag,\n    normalSellerStock,\n    normalWmsStock,\n    minPurchaseLimit,\n    itemSellerSellableStock,\n    itemWmsSellableStock,\n    itemTotalReservedStock,\n    itemNormalStock,\n    modelList {\n      modelid,\n      name,\n      inputOriginPrice,\n      promotionPrice,\n      originPrice,\n      normalStock,\n      pffTag,\n      normalSellerStock,\n      normalWmsStock,\n      modelNormalStock,\n      modelSellerSellableStock,\n      modelWmsSellableStock,\n      modelTotalReservedStock,\n    }\n  }\n}\n    }',
        'variables': {
          'productIds': product_ids,
          'statusType': 0
        }
      },
      json: true
    })

    replace_get_product_by_graphql(this, response)

    return response.data
  }

  async flash_sale_get_list(offset = 0, limit = 10, type = 0, start_time = '', end_time = '') {
    // let url = `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&offset=${offset}&limit=${limit}&type=${type}`
    let url = `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/get_shop_flash_sale_list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&offset=${offset}&limit=${limit}&type=${type}`
    if (start_time && end_time) {
      url += `&start_time=${start_time}&end_time=${end_time}`
    }

    const response = await this.request({
      url: url,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async flash_sale_get_report(promotion_id_list) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/report_list_by_ids/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&promotion_id_list=[{promotion_id_list}]`
        .replace('{promotion_id_list}', promotion_id_list),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async flash_sale_delete(flash_sale_id, time_slot_id) {
    const response = await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/set/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/set_shop_flash_sale/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        flash_sale_id,
        time_slot_id,
        status: 0
      },
      json: true
    })

    return response.data
  }

  async flash_sale_set_status(flash_sale_id, time_slot_id, status) {
    const response = await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/set/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/set_shop_flash_sale/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        flash_sale_id,
        time_slot_id,
        status: status
      },
      json: true
    })

    return response.data
  }

  async flash_sale_get_time_slot(start_time, end_time) {
    const response = await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/time_slot/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}`
      url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/get_time_slot_id/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async flash_sale_create(time_slot_id) {
    if (this.is_buff) return {code: 0}

    const response = await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/set/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/set_shop_flash_sale/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {time_slot_id},
      json: true
    })

    return response.data
  }

  async flash_sale_get_product(offset, limit) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v4/public/product_selector/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&offset={offset}&limit={limit}&is_ads=0&need_brand=0`
        .replace('{offset}', offset)
        .replace('{limit}', limit),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    replace_marketing_product_selector(this, response)

    return response.data
  }

  async flash_sale_save_batch_items(form) {
    const response = await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/batch_items/set/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/set_shop_flash_sale_items/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        ...form,
        use_global_category: true
      },
      json: true
    })

    // todo: write log
    axios.post(API.URL_API_SRV_2 + '/mipee/log/flash_sale_set_batch_items', {
      form: form,
      response: response,
      shop_id: this._id
    }, cf())
      .catch(console.error)

    return response.data
  }

  async flash_sale_set_item_sequence(form) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/set_item_sequence/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: form,
      json: true
    })

    return response.data
  }

  async flash_sale_get_misleading_discount(form) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v4/public/misleading_discount/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: form,
      json: true
    })

    return response.data
  }

  async flash_sale_get_item_ids(flash_sale_id) {
    const response = await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/item_ids/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&flash_sale_id={flash_sale_id}`
      url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/get_shop_flash_sale_item_id_list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&flash_sale_id={flash_sale_id}`
        .replace('{flash_sale_id}', flash_sale_id),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async flash_sale_get_batch_items(flash_sale_id, offset, limit) {
    const response = await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/batch_items/get?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&flash_sale_id={flash_sale_id}&offset={offset}&limit={limit}`
      url: `https://banhang.shopee.vn/api/marketing/v4/shop_flash_sale/get_shop_flash_sale_item/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&flash_sale_id={flash_sale_id}&offset={offset}&limit={limit}`
        .replace('{flash_sale_id}', flash_sale_id)
        .replace('{offset}', offset)
        .replace('{limit}', limit),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async flash_sale_get_product_ranking(promotion_id, allow_cache = false) {
    const cache_type = 'flash_sale_product_ranking'

    // todo: get cache
    if (allow_cache) {
      const cache_response = await get_cache({
        data_id: promotion_id,
        type: cache_type,
        shop_id: this.shop_id
      })
      if (cache_response && cache_response.data) {
        return typeof cache_response.data === 'string' ? JSON.parse(cache_response.data) : cache_response.data
      }
    }

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v3/marketing/flash-sale-details/product-ranking/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&promotion_id={promotion_id}&order_type=confirmed`
        .replace('{promotion_id}', promotion_id),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    // todo: cache data
    if (allow_cache && response && response.data && response.data.code === 0) {
      cache_data({
        data_id: promotion_id,
        data: JSON.stringify(response.data),
        type: cache_type,
        shop_id: this.shop_id
      })
    }

    return response.data
  }

  async dashboard__key_metrics(start_time, end_time, period) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v3/dashboard/key-metrics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&fetag=fetag`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    replace_dashboard__key_metrics(this, response)

    return response.data
  }

  async marketing_info() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v3/pas/meta/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_get_home_page(offset, limit, start_time, end_time, campaign_state = 'all', campaign_type = 'cpc_homepage') {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v3/pas/homepage/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&campaign_type={campaign_type}&campaign_state={campaign_state}&sort_key=performance&sort_direction=1&search_content=&start_time={start_time}&end_time={end_time}&offset={offset}&limit={limit}`
        .replace('{offset}', offset)
        .replace('{limit}', limit)
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{campaign_state}', campaign_state)
        .replace('{campaign_type}', campaign_type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_get_search_ads(start_time, end_time, offset, limit, campaign_state = 'all', search_content = '') {
    const url = `https://banhang.shopee.vn/api/marketing/v3/pas/homepage/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&campaign_type=search&campaign_state={campaign_state}&sort_key=performance&sort_direction=1&search_content={search_content}&start_time={start_time}&end_time={end_time}&offset={offset}&limit={limit}`
      .replace('{start_time}', dayjs(start_time).startOf('d').unix().toString())
      .replace('{end_time}', dayjs(end_time).endOf('d').unix().toString())
      .replace('{offset}', offset)
      .replace('{limit}', limit)
      .replace('{campaign_state}', campaign_state)
      .replace('{search_content}', search_content)
    const response = await this.request({
      url,
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    replace_marketing_get_search_ads(this, response)

    // return this.parseBody(resp.body).data.campaign_ads_list;
    return response.data && response.data.data && response.data.data.campaign_ads_list ? response.data.data.campaign_ads_list : []
  }

  async marketing_search_report_by_time(start_time, end_time, agg_interval = '96') {
    const url = `https://banhang.shopee.vn/api/marketing/v3/pas/report/search_report_by_time/?start_time={start_time}&end_time={end_time}&agg_interval={agg_interval}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`
      .replace('{start_time}', dayjs(start_time).startOf('d').unix().toString())
      .replace('{end_time}', dayjs(end_time).endOf('d').unix().toString())
      .replace('{agg_interval}', agg_interval)
    return await this.request({
      url,
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_shop_report_by_time(start_time, end_time, placement_list = '[1,2,5,8]', agg_interval = '96') {
    const url = `https://banhang.shopee.vn/api/marketing/v3/pas/report/shop_report_by_time/?start_time={start_time}&end_time={end_time}&placement_list={placement_list}&agg_interval={agg_interval}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`
      .replace('{start_time}', dayjs(start_time).startOf('d').unix().toString())
      .replace('{end_time}', dayjs(end_time).endOf('d').unix().toString())
      .replace('{placement_list}', placement_list)
      .replace('{agg_interval}', agg_interval)
    return await this.request({
      url,
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_detail_report_by_time(start_time, end_time, placement_list, itemid, adsid, agg_interval) {
    agg_interval = generate_agg_interval(start_time, end_time)

    let url = `https://banhang.shopee.vn/api/marketing/v3/pas/report/detail_report_by_time/?start_time={start_time}&end_time={end_time}&placement_list={placement_list}&agg_interval={agg_interval}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`
      .replace('{start_time}', dayjs(start_time).startOf('d').unix().toString())
      .replace('{end_time}', dayjs(end_time).endOf('d').unix().toString())
      .replace('{placement_list}', placement_list)
      .replace('{agg_interval}', agg_interval)

    if (itemid) url += `&itemid=${itemid}`
    if (adsid) url += `&adsid=${adsid}`

    return await this.request({
      url,
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_detail_report_by_time_v2(campaign_id, start_time, end_time, placement_list, itemid, adsid, agg_interval) {
    if (includes_fixed_shop(this.shop_id)) {
      let resp = await this.marketing_get_time_graph('product', dayjs(start_time).startOf('d').unix(), dayjs(end_time).endOf('d').unix(), {campaign_id})
      if (resp) resp = map_graph_by_time_response(resp.data.report_by_time)
      return {data: {data: resp}}
    }

    return this.marketing_detail_report_by_time(start_time, end_time, placement_list, itemid, adsid, agg_interval)
  }

  async marketing_update_keyword(campaignid, keyword_list, placement = 0) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v3/pas/search_ads/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      url: `https://banhang.shopee.vn/api/marketing/v3/pas/search/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaignid,
        placement,
        keyword_list: keyword_list.map(i => _pick(i, ['algorithm', 'keyword', 'match_type', 'price', 'status']))
      },
      json: true
    })
  }

  async marketing_update_keyword_v2(campaignid, keyword_list, placement = 0) {
    if (this.is_buff) return {code: 0}

    if (includes_fixed_shop(this.shop_id)) {
      await this.request({
        url: `https://banhang.shopee.vn/api/pas/v1/product/manual/mass_edit_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
        method: 'PUT',
        headers: await this.x_headers_seller(this.cookie),
        body: {
          campaign_id: campaignid,
          keyword_edit_list: keyword_list.filter(i => i.status === 1).map(i => {
            return {
              keyword: i.keyword,
              type: 'change_match_type',
              change_match_type: {
                match_type: i.match_type === 0 ? 'exact' : 'broad'
              }
            }
          })
        },
        json: true
      })

      return await this.request({
        url: `https://banhang.shopee.vn/api/pas/v1/product/manual/mass_edit_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
        method: 'PUT',
        headers: await this.x_headers_seller(this.cookie),
        body: {
          campaign_id: campaignid,
          keyword_edit_list: keyword_list.filter(i => i.status === 1).map(i => {
            return {
              keyword: i.keyword,
              type: 'change_bid_price',
              change_bid_price: {
                price: this.m__calculate(i.price) * 100000
              }
            }
          })
        },
        json: true
      })
    }

    return this.marketing_update_keyword(campaignid, keyword_list, placement)
  }

  async marketing_update_keyword_status_v2(campaignid, keyword_list, placement = 0) {
    if (this.is_buff) return {code: 0}

    if (includes_fixed_shop(this.shop_id)) {
      return await this.request({
        url: `https://banhang.shopee.vn/api/pas/v1/product/manual/mass_edit_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
        method: 'PUT',
        headers: await this.x_headers_seller(this.cookie),
        body: {
          campaign_id: campaignid,
          keyword_edit_list: keyword_list.map(i => {
            return {
              keyword: i.keyword,
              type: i.status === 1 ? 'restore' : 'delete'
            }
          })
        },
        json: true
      })
    }

    return this.marketing_update_keyword(campaignid, keyword_list, placement)
  }

  async marketing_add_keyword__v2(campaignid, keyword_list, placement = 0) {
    if (this.is_buff) return {code: 0}

    if (includes_fixed_shop(this.shop_id)) {
      return await this.request({
        url: `https://banhang.shopee.vn/api/pas/v1/product/manual/mass_edit_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
        method: 'PUT',
        headers: await this.x_headers_seller(this.cookie),
        body: {
          campaign_id: campaignid,
          keyword_edit_list: keyword_list.map(i => {
            return {
              keyword: i.keyword,
              type: 'add'
            }
          })
        },
        json: true
      })
    }

    return this.marketing_update_keyword(campaignid, keyword_list, placement)
  }

  async marketing_update_campaign_status(campaignid_list, action, need_campaign = true) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v3/pas/mass_edit/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaignid_list,
        action,
        need_campaign
      },
      json: true
    })
  }

  async marketing_homepage_report_by_time(start_time, end_time, placement_list, agg_interval) {
    agg_interval = generate_agg_interval(start_time, end_time)

    const url = `https://banhang.shopee.vn/api/marketing/v3/pas/report/homepage_report_by_time/?start_time={start_time}&end_time={end_time}&placement_list={placement_list}&agg_interval={agg_interval}&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`
      .replace('{start_time}', dayjs(start_time).startOf('d').unix().toString())
      .replace('{end_time}', dayjs(end_time).endOf('d').unix().toString())
      .replace('{placement_list}', placement_list)
      .replace('{agg_interval}', agg_interval)
    return await this.request({
      url,
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_ads_price_toggle(campaignid, toggle_on, toggle_type) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v3/pas/ads_price/toggle/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaignid,
        toggle_on,
        toggle_type
      },
      json: true
    })
  }

  async marketing_update_placement4(campaignid, status) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v3/pas/search_ads/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      url: `https://banhang.shopee.vn/api/marketing/v3/pas/search/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaignid,
        placement: 4,
        status
      },
      json: true
    })
  }

  async marketing_update_shop_ads(data) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      // url: `https://banhang.shopee.vn/api/marketing/v3/pas/search_ads/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      url: `https://banhang.shopee.vn/api/marketing/v3/pas/search/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })
  }

  async update_product(product) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: `https://banhang.shopee.vn/api/v3/product/update_product/?version=3.1.0&SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&source=seller_center`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: [{...product}],
      json: true
    })
  }

  async dashboard_export(start_time, end_time, period) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/mydata/v4/dashboard/export/?start_ts={start_time}&end_ts={end_time}&period={period}'
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      encoding: null
    })

    return response.data
  }

  async get_product_performance(offset, limit, start_time, end_time, period) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v2/product/performance/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&metric_ids=all&sort_by=placed_units.desc&offset={offset}&limit={limit}`
        .replace('{offset}', offset)
        .replace('{limit}', limit)
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_product_performance_v2(page_num, page_size, start_time, end_time, period, keyword = '') {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v2/product/performance/batch/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&sort_by=placed_units.desc&page_size={page_size}&page_num={page_num}&category_type=shopee&category=-1&keyword={keyword}&metric_ids=all&start_time={start_time}&end_time={end_time}&period={period}`
        .replace('{page_num}', page_num)
        .replace('{page_size}', page_size)
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period)
        .replace('{keyword}', encodeURIComponent(keyword)),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_product_performance_v3(page_num, page_size, start_time, end_time, period, keyword = '') {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v3/product/performance/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&order_by=placed_units.desc&page_size={page_size}&page_num={page_num}&category_type=shopee&category=-1&keyword={keyword}&metric_ids=all&start_time={start_time}&end_time={end_time}&period={period}`
        .replace('{page_num}', page_num)
        .replace('{page_size}', page_size)
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period)
        .replace('{keyword}', encodeURIComponent(keyword)),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    replace_get_product_performance_v3(this, response)

    return response
  }

  async get_composition_buyers(start_time, end_time, period, order_type = 'placed') {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v2/sales/composition/buyers/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&order_type={order_type}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period)
        .replace('{order_type}', order_type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_composition_pricezone(start_time, end_time, period, order_type = 'placed') {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v2/sales/composition/pricezone/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&order_type={order_type}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period)
        .replace('{order_type}', order_type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_overview_funnel(start_time, end_time, period) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v3/sales/overview/funnel/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_traffic_overview(dt, period) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/traffic/dashboard/overview/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&period={period}&dt={dt}`
        .replace('{dt}', dt)
        .replace('{period}', period),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_metrics_customer(start_time, end_time, period, order_type) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v1/metrics/shop/customers/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&orderType={order_type}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period)
        .replace('{order_type}', order_type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_get_voucher(offset, limit, promotion_type, voucher_name = '', voucher_code = '') {
    let url = `https://banhang.shopee.vn/api/marketing/v3/voucher/list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&offset={offset}&limit={limit}&promotion_type={promotion_type}`
      .replace('{offset}', offset)
      .replace('{limit}', limit)
      .replace('{promotion_type}', promotion_type)

    if (voucher_name) url += `&voucher_name=${voucher_name}`
    if (voucher_code) url += `&voucher_code=${voucher_code}`

    return await this.request({
      url: url,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_get_voucher_detail(voucher_id) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v3/voucher/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&voucher_id={voucher_id}`
        .replace('{voucher_id}', voucher_id),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_create_voucher(form, is_update) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/voucher/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: is_update ? 'PUT' : 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: form,
      json: true
    })
  }

  async marketing_create_follow_prize(form) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v4/follow_prize/create/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: form,
      json: true
    })
  }

  async marketing_follow_prize_operation(data) {
    if (this.is_buff) return {code: 0}

    const get_campaignids_by_promotionids_response = await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v4/follow_prize/get_campaignids_by_promotionids/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {promotion_ids: [data.voucher_id]},
      json: true
    })

    if (get_campaignids_by_promotionids_response && get_campaignids_by_promotionids_response.data && get_campaignids_by_promotionids_response.data.code === 0) {
      const {campaign_lites} = get_campaignids_by_promotionids_response.data.data

      if (campaign_lites && campaign_lites.length) {
        return await this.request({
          url: 'https://banhang.shopee.vn/api/marketing/v4/follow_prize/operation/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
          method: 'POST',
          headers: await this.x_headers_seller(this.cookie),
          body: {
            campaign_id: campaign_lites[0].campaign_id,
            action: data.action
          },
          json: true
        })
      }
    }
  }

  async marketing_stop_voucher(voucher_id) {
    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/voucher/stop/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: {voucher_id},
      json: true
    })
  }

  async marketing_delete_voucher(voucher_id) {
    return await this.request({
      url: 'https://banhang.shopee.vn/api/marketing/v3/voucher/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'DELETE',
      headers: await this.x_headers_seller(this.cookie),
      body: {voucher_id},
      json: true
    })
  }

  async marketing_get_bundle_deal(period_from, period_to) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v3/bundle_deal/standard_search/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&search_type=promotion_name&period_to={period_to}&period_from={period_from}`
        .replace('{period_from}', period_from)
        .replace('{period_to}', period_to),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_get_bundle_deal_order(bundle_deal_id, offset, limit) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v3/bundle_deal/order/info/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&bundle_deal_id={bundle_deal_id}&limit={limit}&offset={offset}`
        .replace('{bundle_deal_id}', bundle_deal_id)
        .replace('{offset}', offset)
        .replace('{limit}', limit),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_get_bundle_deal_metrics(start_time, end_time, period = 'month') {
    return await this.request({
      // url: `https://banhang.shopee.vn/api/mydata/marketing/bundle/key-metrics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&order_type=confirmed`
      url: `https://banhang.shopee.vn/api/mydata/v2/marketing/bundle/key-metrics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&order_type=confirmed`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_get_voucher_performance(start_time, end_time, period = 'month') {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/marketing/voucher/performance/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_get_voucher_metrics(start_time, end_time, period = 'month', order_type = 'confirmed') {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/marketing/voucher/key-metrics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&order_type={order_type}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period)
        .replace('{order_type}', order_type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_get_flash_sale_performance(page_size, page_offset) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/marketing/flash-sale/overview/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&page_size={page_size}&page_offset={page_offset}&sort_by=`
        .replace('{page_size}', page_size)
        .replace('{page_offset}', page_offset),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_get_flash_sale_metrics(start_time, end_time, period = 'month') {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/marketing/flash-sale/key-metrics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_shop_profile() {
    return await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v4/shop/profile/get?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_order_id_list() {
    return await this.request({
      url: `https://banhang.shopee.vn/api/v3/order/get_order_id_list?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&page_size=40&page_number=1&from_page_number=1&total=0&flip_direction=ahead&page_sentinel=0,0&sort_by=create_date_desc&backend_offset=`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_canceled_order_id_list() {
    return await this.request({
      url: `https://banhang.shopee.vn/api/v3/order/get_order_id_list?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&from_page_number=1&source=cancelled_all&page_size=40&page_number=1&total=0&is_massship=false`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async get_listing_optimizer() {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v4/selling-coach/listing-optimiser/overview/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async seller_competing_products(itemid, l2catid, l3catid) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v4/seller-coach/seller-competing-products/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&itemid={itemid}&l2catid={l2catid}&l3catid={l3catid}`
        .replace('{itemid}', itemid)
        .replace('{l2catid}', l2catid)
        .replace('{l3catid}', l3catid),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async marketing_list_keyword_hint(keyword, product_id, placement) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/pas/v1/setup_helper/list_keyword_hint/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      body: {
        keyword: keyword,
        placement: product_id ? +placement : 3,
        suggest_log_data: {
          page: 'suggest_creation'
        },
        item_id: product_id || null
      },
      headers: await this.x_headers_seller(this.cookie),

      json: true
    })

    return response.data
  }

  async shopee_flash_sale_get(data) {
    return await this.request({
      url: 'https://banhang.shopee.vn/api/mkt/fscmt/sellerapi/session/search?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })
  }

  async shopee_flash_sale_cluster_get(data) {
    return await this.request({
      url: 'https://banhang.shopee.vn/api/mkt/fscmt/sellerapi/cluster/search?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })
  }

  async shopee_flash_sale_product_get(cluster_id) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mkt/fscmt/sellerapi/product/list?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&cluster_id=${cluster_id}&page_num=1&page_size=100`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })
  }

  async shopee_flash_sale_product_get_display_image(session_id, item_ids) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mkt/fscmt/sellerapi/product/display_image?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        session_id,
        item_ids
      },
      json: true
    })
  }

  async shopee_flash_sale_product_submit(form) {
    return await this.request({
      url: `https://banhang.shopee.vn/api/mkt/fscmt/sellerapi/product/submit?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: form,
      json: true
    })
  }

  async upload_image(file) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/v3/general/upload_image/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&ratio=1`,
      method: 'POST',
      headers: {
        ...await this.x_headers_seller(this.cookie),
        'Content-Type': 'multipart/form-data'
      },
      upload: {
        base64: await get_base64(file),
        filename: file.name
      },
      json: true
    })

    if (response && response.data && response.data.data && response.data.data.resource_id) {
      return response
    } else {
      const response = await axios.post(API.URL_API_SRV_2 + '/mipee/open_platform/upload_image', {
        shop_id: this.shop_id,
        filename: file.name,
        base64: await get_base64(file),
      }, cf())

      if (response && response.data && response.data.data && response.data.data.response && response.data.data.response.image_info && response.data.data.response.image_info.image_id) {
        return {data: {data: {resource_id: response.data.data.response.image_info.image_id}}}
      }
    }

    return null
  }

  async boost_ads_marketing_get_campaign(start_time, end_time, offset, limit, campaign_state = 'all') {
    const url = `https://banhang.shopee.vn/api/marketing/v3/pas/homepage/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&campaign_type=boost_homepage&campaign_state={campaign_state}&sort_key=performance&sort_direction=1&search_content=&start_time={start_time}&end_time={end_time}&offset={offset}&limit={limit}`
      .replace('{start_time}', dayjs(start_time).startOf('d').unix().toString())
      .replace('{end_time}', dayjs(end_time).endOf('d').unix().toString())
      .replace('{offset}', offset)
      .replace('{limit}', limit)
      .replace('{campaign_state}', campaign_state)

    const response = await this.request({
      url,
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data && response.data.data && response.data.data.campaign_ads_list ? response.data.data.campaign_ads_list : []
  }

  async boost_ads_marketing_update_campaign(data) {
    if (this.is_buff) return {code: 0}

    return await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v3/pas/boost/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })
  }

  async get_landing_page_campaign_list(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/get_landing_page_campaign_list?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  // todo: flash sale shopee
  async get_session_list_for_sc_v2(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/session/get_session_list_for_sc_v2?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async get_nominated_entity_list(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/nominated/nominated_entity_list?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async get_preview_entity_list(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/preview/preview_list?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async edit_online_nominated_entity(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/nominated/edit_entity_online?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async submit_online_nominated_entity(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/preview/submit_entity_online?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async add_preview_entity(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/preview/add?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async edit_preview_entity(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/preview/edit?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async delete_preview_entity(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/preview/delete?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async withdraw_entity(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/nominated/withdraw_entity?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async get_session_nomination_statistics(session_id) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mkt/cmt/session/get_session_nomination_statistics?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_scene: 'CAMPAIGN_SCENE_FLASH_SALE',
        session_id: session_id
      },
      json: true
    })

    return response.data
  }

  // todo: end flash sale shopee

  async get_product_over_view(start_time, end_time, period) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mydata/v2/product/overview/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async decoration_get_draft() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/n/decoration/pc_homepage/draft_get/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async get_chat_performance() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/webchat/api/workbenchapi/v1.2/sc/chat_performance?shop_id=${this.shop_id}&SPC_CDS=_SPC_CDSSPC_CDS_VER=2`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async search_shop_rating_comments_new() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/v3/settings/search_shop_rating_comments_new/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&rating_star=5,4,3,2,1&page_number=1&page_size=20&cursor=0&from_page_number=1`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async voucher__key_metrics(start_time, end_time, period, order_type = 'confirmed') {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mydata/marketing/voucher/key-metrics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&order_type={order_type}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period)
        .replace('{order_type}', order_type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async flash_sale__key_metrics(start_time, end_time, period, order_type = 'confirmed') {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mydata/marketing/flash-sale/key-metrics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&order_type={order_type}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period)
        .replace('{order_type}', order_type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async new_discount__key_metrics(start_time, end_time, period, promotion_type = '1', order_type = 'confirmed') {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/mydata/marketing/new-discount/key-metrics/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&start_time={start_time}&end_time={end_time}&period={period}&promotion_type={promotion_type}&order_type={order_type}`
        .replace('{start_time}', start_time)
        .replace('{end_time}', end_time)
        .replace('{period}', period)
        .replace('{promotion_type}', promotion_type)
        .replace('{order_type}', order_type),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  // todo: marketing pas
  async marketing_pas_get_campaigns(start_time, end_time, offset, limit, filter, sort_by_gmv = false) {
    const split_times = split_data_every_three_months(start_time * 1000, end_time * 1000).reverse()
    // console.log('split_times', split_times)

    const data = []

    for (const split_time of split_times) {
      const body = {
        start_time: split_time.start,
        end_time: split_time.end,
        filter_list: [filter],
        offset: offset,
        limit: limit
      }
      if (sort_by_gmv) {
        body['sorting'] = {
          direction: 'desc',
          key: 'broad_gmv'
        }
      }

      const response = await this.request({
        url: `https://banhang.shopee.vn/api/pas/v1/homepage/query/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
        method: 'POST',
        headers: await this.x_headers_seller(this.cookie),
        body: body,
        json: true
      })

      replace_marketing_pas_get_campaigns(this, response)

      // console.log(new Date(split_time.start * 1000))
      // console.log(new Date(split_time.end * 1000))
      // console.log(response.data)
      if (response.data && response.data.data && response.data.data.entry_list) {
        const log_data = [];

        for (const item of response.data.data.entry_list) {
          log_data.push({
            campaign_id: item.campaign.campaign_id,
            daily_budget: item.campaign.daily_budget / 100000,
            roi_two_target: item.campaign.roi_two_target ? item.campaign.roi_two_target / 100000 : 0,
          })

          const found = data.find(i => i.campaign.campaign_id === item.campaign.campaign_id)
          if (found) {
            for (const key of Object.keys(found.report)) {
              found.report[key] += item.report[key]
            }
            recalculate_metrics(found.report)
          } else {
            data.push(item)
          }
        }

        axios.post(API.URL_API_SRV_2 + '/mipee/shopee_ads/log_campaigns', {data: log_data}, cf()).catch(console.error)
      }

      if (response.data && response.data.code === 5) {
        const response = await axios.post(API.URL_API_SRV_2 + '/mipee/shopee_ads/get_campaigns_data', {
          shop_id: this._id,
          start_time: split_time.start,
          end_time: split_time.end,
        }, cf())
        if (response.data && response.data.data) {
          for (const item of response.data.data) {
            const found = data.find(i => i.campaign.campaign_id === item.campaign_id)
            if (found) {
              for (const key of Object.keys(found.report)) {
                if (+item.report[key]) found.report[key] += +item.report[key]
              }
              recalculate_metrics(found.report)
            }
          }
        }
      }
    }

    return {data: {entry_list: data}}
  }

  async marketing_pas_get_campaign_detail(campaign_id) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/product/get/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_id,
        header: {}
      },
      json: true
    })

    return response ? response.data : null
  }

  async marketing_pas_get_ads_data() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/meta/get_ads_data/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        info_type_list: ['ads_toggle', 'has_ads', 'setup_flow_version', 'ads_credit', 'campaign_day', 'ads_account']
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_get_ads_config() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/config/get/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        required_config_list: ['ads_config', 'bid_price', 'currency', 'link', 'number_constants', 'education_link', 'feature_downgrade']
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_get_report_config() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/report/get_config/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {},
      json: true
    })

    return response.data
  }

  async marketing_pas_update_metric_config(data) {
    if (this.is_buff) return {code: 0}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/report/update_selected_metric_config/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_mass_update(data) {
    if (this.is_buff) return {code: 0}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/homepage/mass_edit/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    // todo: save log
    if (data && data.campaign_id_list && data.campaign_id_list.length > 0) {
      for (const campaign_id of data.campaign_id_list) {
        axios.post(API.URL_API_SRV_2 + '/mipee/log/save_pas_update_campaign', {
          campaign_id: campaign_id,
          campaign_type: null,
          data: JSON.stringify(data),
          type: data.type,
          shop_id: this._id,
          is_mass_update: true
        }, cf()).catch(console.error)
      }
    }
    // end save log

    return response.data
  }

  async marketing_pas_update_campaign(data, type = 'product') {
    if (this.is_buff) return {code: 0}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/${type}/edit/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    if (data && data.campaign_id) {
      axios.post(API.URL_API_SRV_2 + '/mipee/log/save_pas_update_campaign', {
        campaign_id: data.campaign_id,
        campaign_type: type,
        data: JSON.stringify(data),
        type: data.type,
        shop_id: this._id,
        is_mass_update: false
      }, cf()).catch(console.error)
    }

    return response.data
  }

  async marketing_pas_update_keyword(data) {
    if (this.is_buff) return {code: 0}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/product/manual/mass_edit_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'PUT',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_update_keyword_status(campaignid, keyword_list, type = 'product') {
    if (this.is_buff) return {code: 0}

    if (!keyword_list || !keyword_list.length) return {data: {code: 0}}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/${type}/manual/mass_edit_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_id: campaignid,
        keyword_edit_list: keyword_list.map(i => {
          return {
            keyword: i.keyword,
            type: i.status === 1 ? 'restore' : 'delete'
          }
        })
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_update_keyword_type(campaign_id, keyword_list, type = 'product') {
    if (this.is_buff) return {code: 0}

    const update_keyword_list = keyword_list ? keyword_list.filter(i => i.status === 1) : []
    if (!update_keyword_list.length) return {data: {code: 0}}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/${type}/manual/mass_edit_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_id: campaign_id,
        keyword_edit_list: update_keyword_list.map(i => {
          return {
            keyword: i.keyword,
            type: 'change_match_type',
            change_match_type: {
              match_type: i.match_type === 0 ? 'exact' : 'broad'
            }
          }
        })
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_update_keyword_price(campaign_id, keyword_list, type = 'product') {
    if (this.is_buff) return {code: 0}

    const update_keyword_list = keyword_list ? keyword_list.filter(i => i.status === 1) : []
    if (!update_keyword_list.length) return {data: {code: 0}}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/${type}/manual/mass_edit_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_id: campaign_id,
        keyword_edit_list: update_keyword_list.filter(i => i.status === 1).map(i => {
          return {
            keyword: i.keyword,
            type: 'change_bid_price',
            change_bid_price: {
              price: Math.round(this.m__calculate(i.price) * 100000)
            }
          }
        })
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_add_keyword(campaign_id, keyword_list, type = 'product') {
    if (this.is_buff) return {code: 0}

    if (!keyword_list || !keyword_list.length) return {data: {code: 0}}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/${type}/manual/mass_edit_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_id: campaign_id,
        keyword_edit_list: keyword_list.map(i => {
          return {
            keyword: i.keyword,
            type: 'add',
            add: {
              bid_price: Math.round(this.m__calculate(i.price) * 100000),
              match_type: i.match_type === 0 ? 'exact' : 'broad'
            }
          }
        })
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_get_campaign_target_audience(campaign_id) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/target_audience/list_for_single_campaign/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_id: campaign_id,
        header: {}
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_update_campaign_target_audience(data) {
    if (this.is_buff) return {code: 0}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/target_audience/edit/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_update_shop_campaign(data) {
    if (this.is_buff) return {code: 0}

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/shop/edit/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_publish_campaign(data, type = 'product') {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/${type}/publish/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_search_keyword(keyword, product_id, campaign_type = 'product', campaign_id = null) {
    const response = await this.request({
      url: 'https://banhang.shopee.vn/api/pas/v1/setup_helper/list_recommended_keyword/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2',
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        keyword: keyword,
        suggest_log_data: {
          campaign_id: campaign_id,
          page: campaign_id ? 'suggest_after_creation' : 'suggest_creation'
        },
        item_id: product_id || null,
        campaign_type: campaign_type
        // placement: campaign_type === 'product' ? '0' : '3'
      },
      json: true
    })

    for (const item of response.data.data) {
      item.algorithm = item.product_suggest_log_data ? item.product_suggest_log_data.algorithm : 'kwrcmdv2'
      item.recommend_price = this.m__calculate(item.recommended_price / 100000)
    }

    if (response && response.data && response.data.data) {
      axios.post(API.URL_API_SRV_2 + '/mipee/keyword/log_relevance', {
        placement: campaign_type === 'product' ? 0 : 3,
        shop_id: this.shop_id,
        item_id: product_id,
        keywords: response.data.data,
        country: this.country
      }, cf())
        .catch(console.error)
    }

    return response.data
  }


  async marketing_pas_report_trigger(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/report/export_job/trigger/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_report_trigger_or_get_previous(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/report/export_job/trigger_or_get_previous/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_report_get_single_result(export_id) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/report/export_job/get_single_result/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        export_id,
        header: {}
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_report_download(export_id) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/report/export_job/download/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        export_id,
        header: {}
      },
      json: true
    })

    if (response && response.data && response.data.data) {
      const form = {
        file_name: response.data.data.file_name,
        content: response.data.data.content,
        export_id: export_id,
        shop_id: this.shop_id
      }
      axios.post(API.URL_API_SRV_2 + '/mipee/cache/report', form, cf())
        .catch(console.error)
    }

    return response.data
  }

  async marketing_pas_get_non_ads_data() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/meta/get_non_ads_data/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        'info_type_list': ['ext_toggle', 'user_shop'],
        'header': {}
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_get_surge_setting() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/campaign_day/get_surge_setting/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {},
      json: true
    })

    return response.data
  }

  async marketing_pas_set_surge_setting(status) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/campaign_day/set_surge_setting/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {toggle_on: status},
      json: true
    })

    return response.data
  }

  async marketing_pas_get_targeting_bid_price_data(item_id_list) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/product/manual/get_targeting_bid_price_data/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {item_id_list},
      json: true
    })

    return response.data
  }

  async marketing_pas_get_recommended_roi_two_target(item_id, reference_id, campaign_type = 'product_manual') {
    if (campaign_type === 'product') campaign_type = 'product_manual'

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/setup_helper/get_recommended_roi_two_target/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        item_id: item_id,
        reference_id: reference_id,
        campaign_type: campaign_type
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_get_recommended_roi_two_target_by_campaign_id(reference_id, campaign_id, campaign_type = 'product_manual') {
    let request_campaign_type = campaign_type
    if (request_campaign_type === 'product') request_campaign_type = 'product_manual'
    if (request_campaign_type === 'all') request_campaign_type = 'product_manual'
    if (request_campaign_type === 'search') request_campaign_type = 'product_manual'
    if (request_campaign_type === 'keyword') request_campaign_type = 'product_manual'
    if (request_campaign_type === 'targeting') request_campaign_type = 'product_manual'

    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/setup_helper/get_recommended_roi_two_target/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_id: campaign_id,
        campaign_type: request_campaign_type,
        reference_id: reference_id
      },
      json: true
    })

    return response.data
  }

  async check_duplicate_ongoing_manual_product(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/banner/check_duplicate_ongoing_manual_product/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_operation_log_query(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/operation_log/query/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_operation_log_query_result_count(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/operation_log/query_result_count/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_get_category_tree() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v4/public/category_tree/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&include_level=3`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_pas_get_page_active_collection_list() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/shopcategory/v4/category/page_active_collection_list/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&page_number=1&page_size=100`,
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_pas_get_products_with_category(offset, limit, category_type, category_id, scene = 'shop_flash_sale') {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/marketing/v4/public/get_product_selector/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2&cursor=&limit={limit}&offset={offset}&is_ads=0&need_brand=0&need_item_model=0&scene={scene}&category_type={category_type}&category={category_id}`
        .replace('{limit}', limit)
        .replace('{offset}', offset)
        .replace('{category_type}', category_type)
        .replace('{category_id}', category_id)
        .replace('{scene}', scene),
      method: 'GET',
      headers: await this.x_headers_seller(this.cookie),
      json: true
    })

    return response.data
  }

  async marketing_pas_trigger_operation_log(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/report/export_job/trigger_operation_log/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_check_duplicate_name(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/shop/check_duplicate_name/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  async marketing_pas_check_live_stream_overlapping_ads_for_roi_two(start_time, end_time, objective = 'max_gmv_roi_two') {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/live_stream/check_overlapping_ads_for_roi_two/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        start_time: start_time,
        end_time: end_time,
        objective: objective,
        header: {}
      },
      json: true
    })

    return response.data
  }

  async marketing_pas_get_bidding_strategy_eligibility() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/shop/get_bidding_strategy_eligibility/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {},
      json: true
    })

    return response.data
  }

  async marketing_pas_get_preview_data() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/shop/get_preview_data/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {},
      json: true
    })

    return response.data
  }

  async marketing_list_item_product_performance(campaign_id, start_time, end_time, reference_id) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/product/mpd/list_item_product_performance/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {
        campaign_id: campaign_id,
        start_time: start_time,
        end_time: end_time,
        reference_id: reference_id,
        header: {}
      },
      json: true
    })

    return response.data
  }

  async marketing_get_smart_booster() {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/smart_booster/get/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: {},
      json: true
    })

    return response.data
  }

  async marketing_set_smart_booster(data) {
    const response = await this.request({
      url: `https://banhang.shopee.vn/api/pas/v1/smart_booster/set/?SPC_CDS=_SPC_CDS&SPC_CDS_VER=2`,
      method: 'POST',
      headers: await this.x_headers_seller(this.cookie),
      body: data,
      json: true
    })

    return response.data
  }

  // end marketing

  m__calculate(arg) {
    if (!arg) return 0
    arg = +arg

    if (this.is_floor) {
      return Math.floor(arg)
    } else {
      return parseFloat(arg.toFixed(2))
    }
  }

  m__map_keyword_state(keyword) {
    if (keyword.state === 'active') return 1
    if (keyword.state === 'deleted') return 0
    return 2
  }
}

// end class

function cf() {
  return {headers: {authorization: store.state.userInfo.token}}
}

async function UPDATE_SELLER_ACCOUNT(_id, username, password, shop_id, cookie, pin_password = '', channel = 'shopee_marketing', name = '', device_id = '', token = '') {
  try {
    const shop_resp = await axios.get(API.shopee_manager__get_shop + '?channel=shopee_marketing', cf())
    const shop = shop_resp.data.data.find(i => i._id === _id)
    if (shop && shop_id) {
      shop.extra_data = _omit(shop.extra_data, ['wrong_pwd', 'is_needed_otp', 'is_error_api', 'is_banned', 'is_need_ivs', 'too_frequent'])
      return await axios.post(API.shopee_manager__add_shop, {
        ...shop,
        _id,
        username,
        password,
        shop_id,
        cookie,
        pin_password,
        channel,
        name,
        device_id,
        token
      }, cf())
    } else {
      // console.error(`SP_USER shop not found: ${username}`)
      console.error('...')
      return null
    }
  } catch (e) {
    console.error(e)
  }
}

function generate_agg_interval(start_time, end_time) {
  const now = dayjs()
  const start = dayjs(start_time)
  const end = dayjs(end_time)

  let agg = 96

  if (end.diff(start, 'day') >= 0) agg = 1
  if (end.diff(start, 'day') >= 1) agg = 4
  if (end.diff(start, 'day') >= 4) agg = 12
  if (end.diff(start, 'day') >= 12) agg = 96
  if (agg === 1 && start.diff(now, 'day') !== 0) agg = 4
  // if (agg === 1 && start.diff(now, 'day') !== 0) agg = 1

  return agg
}

function remove_unicode(value) {
  if (typeof value === 'undefined') {
    return ''
  }
  value = value
    .toString()
    .toLowerCase()
  value = value.replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a')
  value = value.replace(/[èéẹẻẽêềếệểễ]/g, 'e')
  value = value.replace(/[ìíịỉĩ]/g, 'i')
  value = value.replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o')
  value = value.replace(/[ùúụủũưừứựửữ]/g, 'u')
  value = value.replace(/[ỳýỵỷỹ]/g, 'y')
  value = value.replace(/đ/g, 'd')
  return value
}

function includes_fixed_shop(shop_id) {
  return store.state.new_campaign_list.includes(shop_id)
}

function cache_data(data) {
  axios.post(API.URL_API_SRV_2 + '/mipee/cache/update', data, cf())
    .catch(console.error)
}

async function get_cache(data) {
  try {
    const response = await axios.post(API.URL_API_SRV_2 + '/mipee/cache/get', data, cf())
    return response.data
  } catch (e) {
    console.error('get cache error:', e)
    return null
  }
}

function split_data_every_three_months(start_date, end_date) {
  let start = dayjs(start_date)
  let end = dayjs(end_date)
  // let end = dayjs(end_date).isBefore(dayjs(), 'd')
  //   ? dayjs(end_date).isBefore(dayjs(), 'd')
  //   : dayjs().endOf('day')

  const result = []

  while (!end.isSameOrBefore(start)) {
    const prev = end.subtract(3, 'month')

    if (prev.isBefore(start)) {
      prev.set(start)
    }

    result.push({
      start: prev.isBefore(start) ? start.startOf('day').unix() : prev.startOf('day').unix(),
      end: end.endOf('day').unix()
    })

    end = prev;
  }

  return result.reverse()
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}



// WEBPACK FOOTER //
// ./src/addon/SPUserV4.js